var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { DateTime } from 'luxon';
import { JsonCalendar } from 'json-calendar';
import Typography from '../Typography';
import theme from '../theme';
var defaultTheme = theme;
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  && {\n    table {\n      margin-top: 0.5rem;\n      width: 100%;\n      height: 100%;\n      text-align: center;\n      border-collapse: collapse;\n      p {\n        margin: 0;\n      }\n      th {\n        display: table-cell;\n        color: ", ";\n        text-align: center;\n        text-transform: uppercase;\n      }\n\n      th,\n      .previous,\n      .next {\n        button:not(.selected) {\n          color: ", ";\n        }\n      }\n\n      tbody {\n        display: table-row-group;\n\n        th {\n          display: table-cell;\n        }\n\n        tr {\n          display: table-row;\n        }\n\n        td {\n          display: table-cell;\n\n          button {\n            width: 2rem;\n            height: 2rem;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  width: 100%;\n\n  && {\n    table {\n      margin-top: 0.5rem;\n      width: 100%;\n      height: 100%;\n      text-align: center;\n      border-collapse: collapse;\n      p {\n        margin: 0;\n      }\n      th {\n        display: table-cell;\n        color: ",
    ";\n        text-align: center;\n        text-transform: uppercase;\n      }\n\n      th,\n      .previous,\n      .next {\n        button:not(.selected) {\n          color: ",
    ";\n        }\n      }\n\n      tbody {\n        display: table-row-group;\n\n        th {\n          display: table-cell;\n        }\n\n        tr {\n          display: table-row;\n        }\n\n        td {\n          display: table-cell;\n\n          button {\n            width: 2rem;\n            height: 2rem;\n          }\n        }\n      }\n    }\n  }\n"])), function (props) {
    var _a, _b, _c, _d, _e;
    return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.text) === null || _c === void 0 ? void 0 : _c.secondary) || ((_e = (_d = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.palette) === null || _d === void 0 ? void 0 : _d.text) === null || _e === void 0 ? void 0 : _e.secondary);
}, function (props) {
    var _a, _b, _c, _d, _e;
    return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.light) || ((_e = (_d = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.palette) === null || _d === void 0 ? void 0 : _d.primary) === null || _e === void 0 ? void 0 : _e.light);
});
var DateButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  border: none;\n  background: transparent;\n  outline: none;\n  margin: 0.25rem;\n  border-radius: 100%;\n  cursor: pointer;\n\n  &.month-day {\n    color: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n  }\n\n  &.today {\n    background: ", ";\n  }\n\n  &.selected {\n    color: ", ";\n    background: ", ";\n  }\n"], ["\n  color: ",
    ";\n  border: none;\n  background: transparent;\n  outline: none;\n  margin: 0.25rem;\n  border-radius: 100%;\n  cursor: pointer;\n\n  &.month-day {\n    color: ",
    ";\n  }\n\n  &:hover {\n    background: ",
    ";\n  }\n\n  &.today {\n    background: ",
    ";\n  }\n\n  &.selected {\n    color: ",
    ";\n    background: ",
    ";\n  }\n"])), function (props) {
    var _a, _b, _c, _d, _e;
    return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.text) === null || _c === void 0 ? void 0 : _c.disabled) || ((_e = (_d = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.palette) === null || _d === void 0 ? void 0 : _d.text) === null || _e === void 0 ? void 0 : _e.disabled);
}, function (props) {
    var _a, _b, _c, _d, _e;
    return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.text) === null || _c === void 0 ? void 0 : _c.primary) || ((_e = (_d = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.palette) === null || _d === void 0 ? void 0 : _d.text) === null || _e === void 0 ? void 0 : _e.primary);
}, function (props) {
    var _a, _b, _c;
    return ((_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.primary) ? props.theme.palette.primary[50]
        : (_c = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.palette) === null || _c === void 0 ? void 0 : _c.primary[50];
}, function (props) {
    var _a, _b, _c;
    if ((_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.core) {
        return props.theme.palette.core[200];
    }
    return ((_c = defaultTheme.palette) === null || _c === void 0 ? void 0 : _c.core) ? defaultTheme.palette.core[200]
        : '#DBDCDF';
}, function (props) {
    var _a, _b, _c, _d, _e;
    return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.contrastText) || ((_e = (_d = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.palette) === null || _d === void 0 ? void 0 : _d.primary) === null || _e === void 0 ? void 0 : _e.contrastText);
}, function (props) {
    var _a, _b, _c, _d, _e;
    return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.primary) === null || _c === void 0 ? void 0 : _c.main) || ((_e = (_d = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.palette) === null || _d === void 0 ? void 0 : _d.primary) === null || _e === void 0 ? void 0 : _e.main);
});
var weekKeys = [
    'first-week',
    'second-week',
    'third-week',
    'fourth-week',
    'fifth-week',
    'sixth-week',
];
var classNames = function (day, selectedDate) {
    var className = day.className;
    var daysDiff = DateTime.fromJSDate(day.date).diff(DateTime.fromJSDate(selectedDate), 'days').days;
    if (daysDiff === 0 || (daysDiff > -1 && daysDiff < 0)) {
        className += ' selected';
    }
    return className;
};
var CalendarUncontrolled = function (_a) {
    var date = _a.date, month = _a.month, onDateClick = _a.onDateClick;
    var calendar = new JsonCalendar({
        year: month.getFullYear(),
        monthIndex: month.getMonth(),
    });
    var handleDateClicked = React.useCallback(function (clickedDate) {
        return function () {
            onDateClick(clickedDate);
        };
    }, [onDateClick]);
    return (React.createElement(Wrapper, null,
        React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", { key: "days-of-the-week" }, calendar &&
                    calendar.dayNames.map(function (day) {
                        return (React.createElement("th", { key: day.name },
                            React.createElement(Typography, { variant: "h5" }, day.name.substring(0, 1))));
                    })),
                calendar &&
                    calendar.weeks.map(function (week, index) {
                        var key = weekKeys[index];
                        return (React.createElement("tr", { key: key }, week.map(function (day) {
                            return (React.createElement("td", { "data-testid": "date-buttons-" + day.id, key: day.id },
                                React.createElement(DateButton, { "aria-label": "Date Button " + calendar.monthNames[day.monthIndex] + " " + day.day, type: "button", onClick: handleDateClicked(day.date), tabIndex: -1, className: classNames(day, date) },
                                    React.createElement(Typography, { variant: "body1" }, day.day))));
                        })));
                    })))));
};
var Calendar = React.memo(function (props) {
    var _a = React.useState(null), selectedDate = _a[0], setSelectedDate = _a[1];
    var _b = React.useState(null), selectedMonth = _b[0], setSelectedMonth = _b[1];
    React.useEffect(function () {
        if (typeof props.date === 'string') {
            setSelectedDate(new Date());
        }
        else {
            setSelectedDate(props.date);
        }
    }, [props.date]);
    React.useEffect(function () {
        if (typeof props.month === 'string') {
            setSelectedMonth(new Date());
        }
        else {
            setSelectedMonth(props.month);
        }
    }, [props.month]);
    var onChange = React.useCallback(function (date) {
        if (props.onChange) {
            props.onChange(date);
        }
        setSelectedDate(date);
    }, []);
    return (selectedDate &&
        selectedMonth && (React.createElement(CalendarUncontrolled, { date: selectedDate, month: selectedMonth, onDateClick: onChange })));
});
export default Calendar;
var templateObject_1, templateObject_2;
